import { doc, serverTimestamp, updateDoc } from 'firebase/firestore'
import { firestoreDb } from './firebase'
import { callable } from './callable'

export const isValidAccentColor = (hex: unknown): boolean => {
  return typeof hex === 'string' && /^#[0-9a-fA-F]{6}$/.test(hex.trim())
}

export const blobToBase64 = async (file: Blob): Promise<string> => {
  if (typeof (file as Blob).arrayBuffer === 'function') {
    const buffer = await file.arrayBuffer()
    return Buffer.from(buffer).toString('base64')
  }
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onerror = () => reject(new Error('Could not read image file.'))
    reader.onload = () => {
      const value = typeof reader.result === 'string' ? reader.result : ''
      resolve(value.includes(',') ? value.split(',').pop() ?? '' : value)
    }
    reader.readAsDataURL(file)
  })
}

export async function setWorkspaceBrandLogo(
  workspaceId: string,
  file: Blob,
): Promise<{ logoUrl: string }> {
  const base64 = await blobToBase64(file)
  return callable<{ workspaceId: string; mime: string; base64: string }, { logoUrl: string }>(
    'setWorkspaceBrandLogo',
    {
      workspaceId,
      mime: file.type,
      base64,
    },
  )
}

export async function clearWorkspaceBrandLogo(
  workspaceId: string,
): Promise<{ success: boolean }> {
  return callable<{ workspaceId: string }, { success: boolean }>(
    'clearWorkspaceBrandLogo',
    {
      workspaceId,
    },
  )
}

export async function setWorkspaceAccentColor(
  workspaceId: string,
  hex: string | null,
): Promise<void> {
  if (hex !== null && !isValidAccentColor(hex)) {
    throw new Error('Invalid accent colour format. Must match ^#[0-9a-fA-F]{6}$')
  }
  const cleanHex = hex !== null ? hex.trim() : null
  await updateDoc(doc(firestoreDb, 'workspaces', workspaceId), {
    'branding.accentColor': cleanHex,
    'branding.updatedAt': serverTimestamp(),
  })
}
